import React, { memo } from "react";
import BrandLogo from "../../../components/common/BrandLogo/BrandLogo";
import classes from "./Header.module.css";
import logoImg from "../../../assets/images/svg/Logo.svg";
import NavLinks from "./NavLinks";
import { useNavigate } from "react-router-dom";
import { Link } from "react-scroll";

const sectionLinks = [
  { label: "Home", to: "heroContent" },
  { label: "Problem", to: "procurement_overview" },
  { label: "Modules", to: "features" },
  { label: "Pricing", to: "pricing" },
  { label: "Why bidZ.ai", to: "why_bidz" },
  { label: "Benefits", to: "enterprise_benefits" },
  { label: "Difference", to: "bidz_difference" },
  { label: "Clients", to: "clients" },
  { label: "Contact", to: "contact_us" },
];

const Header = () => {
  const navigate = useNavigate();

  const toHome = () => {
    navigate("/");
  };

  return (
    <header className={`${classes.header} ${classes.flex}`}>
      <div className={classes.container}>
        <div className={`${classes.logo} ${classes.flex}`}>
          <BrandLogo imgSrc={logoImg} imgOnclick={toHome} />
        </div>

        <nav className={classes.sectionNav} aria-label="Page section navigation">
          {sectionLinks.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              smooth="easeOutCubic"
              duration={220}
              offset={-110}
              spy
              activeClass={classes.activeSectionChip}
              className={`${classes.sectionChip} ${item.to === "pricing" ? classes.pricingChip : ""}`}
              href={`#${item.to}`}
            >
              {item.label}
              {item.to === "pricing" && <span className={classes.pricingBadge}>₹ 999+</span>}
            </Link>
          ))}
        </nav>

        <NavLinks sectionLinks={sectionLinks} />
      </div>
    </header>
  );
};

export default memo(Header);
